import type { FC } from "react";

interface SarProps {
  classes?: string;
  color?: string;
}
const Sar: FC<SarProps> = ({ classes, color = "#030712" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      className={classes}
    >
      <path
        d="M11.2015 17.7097L18 16.2812V16.3039C17.9087 17.1051 17.7034 17.8534 17.384 18.5488L10.5856 20V19.9546C10.6768 19.1534 10.8821 18.4051 11.2015 17.7097ZM17.384 14.2404L10.5856 15.6916V11.3832L8.46388 11.8367V14.2177C8.46388 14.4293 8.40304 14.6258 8.28137 14.8073L7.18631 16.4399C6.89734 16.8481 6.5019 17.1051 6 17.2109L0 18.4807V18.458C0.0912548 17.6568 0.296578 16.901 0.61597 16.1905L6.34221 14.9887V12.2902L1.0038 13.4014V13.3787C1.07985 12.5775 1.28517 11.8292 1.61977 11.1338L6.34221 10.1361V1.76871L6.36502 1.74603C6.94297 1.03553 7.64259 0.453515 8.46388 0V9.68254L10.5856 9.22902V2.81179H10.6084C11.1863 2.10128 11.8859 1.51172 12.7072 1.04308V8.77551L18 7.6644V7.70975C17.9087 8.51096 17.7034 9.25926 17.384 9.95465L12.7072 10.9297V13.0839L18 11.9728V11.9955C17.9087 12.7967 17.7034 13.545 17.384 14.2404Z"
        fill={color}
      />
    </svg>
  );
};

export default Sar;
